import React, { FC, useEffect, useState } from 'react'
import { API, getInternalCropTemperatureNodesResponse } from '../../api'
import { Typography } from 'antd'
import { CropTemperatureNodesList } from '../../components/nodes-list/CropTemperatureNodesList'

interface Props {}

export const CropTemperatureNodesPage: FC<Props> = () => {
    const [data, setData] = useState<getInternalCropTemperatureNodesResponse | undefined>()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true)

        API.getInternalCropTemperatureNodes()
            .then((data) => {
                setData(data as getInternalCropTemperatureNodesResponse)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    return (
        <div className="crop-temperature-nodes-page">
            <Typography.Title level={3}>Crop Temperature Nodes</Typography.Title>
            <CropTemperatureNodesList data={data?.nodes} loading={loading} />
        </div>
    )
}
